var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.9889,
    height: 39.9889,
    rx: 10,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4023 27.4945V25.9945H26.5753V27.4945H13.4023ZM13.3735 24.3023L12.0118 16.4695C11.9784 16.4758 11.9409 16.4816 11.8993 16.4868C11.8576 16.4919 11.8201 16.4945 11.7868 16.4945C11.4214 16.4945 11.1138 16.3683 10.8638 16.116C10.6138 15.8635 10.4888 15.557 10.4888 15.1965C10.4888 14.8305 10.6138 14.5194 10.8638 14.2633C11.1138 14.0073 11.4217 13.8793 11.7875 13.8793C12.1532 13.8793 12.464 14.0073 12.72 14.2633C12.9762 14.5194 13.1043 14.8305 13.1043 15.1965C13.1043 15.2895 13.0965 15.3759 13.081 15.4558C13.0657 15.5354 13.0414 15.6105 13.008 15.681L16.1715 17.0233L19.2195 12.8638C19.0555 12.7496 18.9232 12.5994 18.8225 12.4133C18.7219 12.2271 18.6715 12.0266 18.6715 11.8118C18.6715 11.4459 18.7995 11.1349 19.0555 10.8788C19.3115 10.6226 19.6224 10.4945 19.9883 10.4945C20.3539 10.4945 20.665 10.6224 20.9215 10.8783C21.1779 11.1339 21.306 11.4445 21.306 11.81C21.306 12.0292 21.2557 12.2311 21.155 12.4158C21.0544 12.6003 20.922 12.7496 20.758 12.8638L23.806 17.0233L26.9695 15.681C26.9439 15.6128 26.9214 15.5378 26.9023 15.4558C26.8829 15.3739 26.8733 15.2875 26.8733 15.1965C26.8733 14.8305 26.9983 14.5194 27.2483 14.2633C27.4983 14.0073 27.8062 13.8793 28.172 13.8793C28.5377 13.8793 28.8486 14.0073 29.1048 14.2633C29.3608 14.5194 29.4888 14.8305 29.4888 15.1965C29.4888 15.556 29.3605 15.8623 29.104 16.1153C28.8475 16.3681 28.536 16.4945 28.1695 16.4945C28.1402 16.4945 28.1072 16.4903 28.0705 16.482C28.034 16.4737 27.998 16.4695 27.9625 16.4695L26.604 24.3023H13.3735ZM14.6503 22.8023H25.3273L26.2658 17.6463L23.2945 18.883L19.9888 14.3465L16.683 18.883L13.7118 17.6463L14.6503 22.8023Z",
    fill: "#A1A1A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/Step3.dd1940fee2c3581aa860dec5d4be8dca.svg";
export { ForwardRef as ReactComponent };